import { useQuery } from '@tanstack/react-query';
import { reportsApi, reportsQueryKeys } from '../api';
import type { ReportFilters } from '../types';

export function useContractClientReport(filters: ReportFilters) {
  return useQuery({
    queryKey: reportsQueryKeys.contractClient(filters),
    queryFn: () => reportsApi.getContractClientReport(filters),
    enabled: !!filters.contractId,
  });
}
